module.exports = __webpack_public_path__ + "img/12.c8b8135e.jpeg";